import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MessagingPanel = ({ contractor, messages, onSendMessage, onClose }) => {
  const [messageText, setMessageText] = useState('');

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);

    if (diffMins < 60) {
      return `${diffMins} min geleden`;
    } else if (diffHours < 24) {
      return `${diffHours} uur geleden`;
    } else {
      return date?.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
    }
  };

  const handleSend = () => {
    if (messageText?.trim()) {
      onSendMessage(messageText);
      setMessageText('');
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-1030 flex items-center justify-center p-4">
      <div 
        className="bg-white border-2 border-slate-200 rounded-lg w-full max-w-2xl max-h-[90vh] flex flex-col"
        style={{
          boxShadow: '0 20px 60px rgba(0,0,0,0.2), 0 10px 30px rgba(0,0,0,0.12)'
        }}
      >
        <div className="flex items-center justify-between p-4 border-b border-border">
          <div className="flex items-center gap-3">
            <Image
              src={contractor?.avatar}
              alt={contractor?.avatarAlt}
              className="w-10 h-10 rounded-full object-cover"
            />
            <div>
              <h3 className="font-semibold text-base text-foreground">{contractor?.name}</h3>
              <p className="caption text-muted-foreground">{contractor?.specialization}</p>
            </div>
          </div>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </Button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {messages?.map((message) => (
            <div
              key={message?.id}
              className={`flex gap-3 ${message?.sender === 'you' ? 'flex-row-reverse' : ''}`}
            >
              <Image
                src={message?.avatar}
                alt={message?.avatarAlt}
                className="w-8 h-8 rounded-full object-cover flex-shrink-0"
              />
              <div className={`flex-1 ${message?.sender === 'you' ? 'items-end' : 'items-start'} flex flex-col`}>
                <div
                  className={`px-4 py-2 rounded-lg max-w-[80%] ${
                    message?.sender === 'you' ?'bg-primary text-primary-foreground' :'bg-muted text-foreground'
                  }`}
                >
                  <p className="text-sm whitespace-pre-line">{message?.text}</p>
                </div>
                <span className="caption text-muted-foreground mt-1">
                  {formatTimestamp(message?.timestamp)}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="p-4 border-t border-border">
          <div className="flex gap-2">
            <Input
              type="text"
              placeholder="Typ een bericht..."
              value={messageText}
              onChange={(e) => setMessageText(e?.target?.value)}
              onKeyPress={handleKeyPress}
              className="flex-1"
            />
            <Button
              variant="default"
              size="icon"
              onClick={handleSend}
              disabled={!messageText?.trim()}
            >
              <Icon name="Send" size={20} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessagingPanel;